<template>
  <router-view />
</template>
<script setup>
import {
  getUrlParams
} from '@/utils/index'

import {
  setToken
} from '@/utils/auth/index'
import { lStorage } from '@/utils'

import VueCookies from 'vue-cookies'; 

const urlParams = getUrlParams()

if (urlParams.token) {
  setToken(urlParams.token)
}else {
  setToken(VueCookies.get('tal_token'))
}

if(urlParams.actId){
  lStorage.set('activityId', urlParams.actId)
}



</script>
<style scoped>
</style>
